/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Cart redirect disabled to allow cart functionality (13 Sep 2026): the old `href contains 'cart'` check bounced /cart, /cart?discount=... and any utm containing 'cart' to the home page.

   var path = window.location.pathname;

    if (path.includes('/products/christmas-bandana-free-gift')) {
      window.location.href = '/products/christmas-bandana';
    }

    if (path.includes('/products/christmas-ornament-free-gift')) {
      window.location.href = '/products/staffy-christmas-ornament';
    }

    if (path.includes('/products/holiday-stocking-free-gift')) {
      window.location.href = '/products/christmas-stocking';
    }

  // Check if URL has ?freetoy parameter
  const urlParams = new URLSearchParams(window.location.search);
  const hasFreeToyCoupon = urlParams.has('freetoy');
  const giftLineItem = document.querySelectorAll('[data-freetoy-gift]');

  if (hasFreeToyCoupon && giftLineItem.length === 0) {
    const formData = new FormData();

    document.cookie = "free_gift_added=true; path=/; max-age=" + 60 * 60 * 24 * 30;


    formData.append('id', 47382751707386); // Free toy variant ID
    formData.append('quantity', 1);
    //document.querySelectorAll('.reward-block')[0].classList.add('reward-block--selectedd')

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: {
          freeGift: true,
          giftFormData: formData,
        },
        bubbles: false,
      })
    );
  }

  // Init Yotpo back in stock
  window.addEventListener('theme:variant:change', (e) => {
    if (window.smsBumpBackInStock) {
      window.smsBumpBackInStock.changeSelectedVariant(e.detail.variant.id);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();




// Shipping Protection auto-enable lives ONLY in layout/theme.liquid (hscShippingProtectionAuto).
// The UpCart toggle-clicker that used to live here (1.0/1.5/2.0/3.0 s timers + console.log) was the second,
// competing owner that AU removed on 30 Jul 2026 because two auto-enablers made the toggle impossible to turn
// off. Removed on US 13 Sep 2026. Do not re-add an auto-enable here.
